const capitalizeWord = (words: string) => {
  return words.replace(/\b\w/g, ((l: string) => l.toUpperCase()));
}

export default capitalizeWord;
